import { Container, Title, Text } from "@mantine/core";

function App() {
  return (
    <Container
      size="sm"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Title order={1}>Eigo.Dev</Title>
      <Text size="lg" c="dimmed" mt="md">
        Welcome
      </Text>
    </Container>
  );
}

export default App;
